import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField, CircularProgress, Typography } from '@mui/material';
import { debounce } from 'lodash';
import styled from 'styled-components';


const StyledTypography = styled(Typography)(({ theme }) => ({
  color: "#64748b",
  fontSize: "14px",
  fontFamily: "Poppins",
  fontWeight: 500,
  mb: 1,
}));
const StyledAutocomplete = styled(Autocomplete)`
  & .MuiOutlinedInput-root {
    border-radius: 10px;
    transition: all 0.3s ease;

    & fieldset {
      border-color: #e0e0e0;
    }

    &:hover fieldset {
      border-color: #0017E7;
      border-width: 1px;
      box-shadow: 0px 0px 5px 0.4px rgba(0, 23, 231, 0.1);
    }

    &.Mui-focused fieldset {
      border-color: #0017E7;
      border-width: 1px;
      box-shadow: 0px 0px 5px 0.4px rgba(0, 23, 231, 0.1);
    }
  }
`;
const GlobalCityAutocomplete = ({ value, onChange, error, helperText }) => {
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState(null);

  const fetchCities = async (input) => {
    if (input.length < 2) {
      setOptions([]);
      return;
    }
    setLoading(true);
    setApiError(null);
    const url = `https://wft-geo-db.p.rapidapi.com/v1/geo/cities?namePrefix=${input}&limit=10&sort=-population`;
    const options = {
      method: 'GET',
      headers: {
        'X-RapidAPI-Key': 'bc46595fdcmshddf2f6fc08d8206p1e8b2cjsnd0e6b076a2c1',
        'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
      }
    };
    try {
      const response = await fetch(url, options);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      if (data && data.data && Array.isArray(data.data)) {
        const cityOptions = data.data.map(city => ({
          label: `${city.city}, ${city.country}`,
          value: `${city.city}, ${city.countryCode}`
        }));
        setOptions(cityOptions);
      } else {
        setApiError('Unexpected response format from the API');
      }
    } catch (error) {
      console.error('Error fetching cities:', error);
      setApiError(`Failed to fetch cities: ${error.message}`);
      setOptions([]);
    } finally {
      setLoading(false);
    }
  };

  const debouncedFetchCities = debounce(fetchCities, 300);

  useEffect(() => {
    debouncedFetchCities(inputValue);
    return () => {
      debouncedFetchCities.cancel();
    };
  }, [inputValue]);

  return (
    <StyledAutocomplete
      options={options}
      value={value}
      onChange={(event, newValue) => {
        onChange(newValue ? newValue.value : null);
      }}
      onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
      renderInput={(params) => (<>
        {/* <StyledTypography>Location</StyledTypography> */}
        <TextField
          {...params}
          variant="outlined"
          // label="Location"
          error={!!error || !!apiError}
          helperText={helperText || apiError}
          required
          fullWidth
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      </>)}
      loading={loading}
      loadingText="Loading cities..."
      noOptionsText={inputValue.length < 2 ? "Type to search cities" : (apiError ? "Error loading cities" : "No cities found")}
    />
  );
};

export default GlobalCityAutocomplete;